export default (
  stroke = '#1043E7'
) => `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.5 18.501L17.5 34.793L1.20703 18.501L17.5 18.501ZM35.5 18.501L35.5 34.793L19.207 18.501L35.5 18.501ZM17.5 0.5L17.5 16.793L1.20703 0.5L17.5 0.5ZM35.5 0.5V16.793L19.207 0.5L35.5 0.5Z" fill="transparent" stroke="${stroke}"/>
</svg>
`;
